const BaseSectionPresets = {
  BaseSection: {
    attrs: {
      showBackButton: true
    }
  }
};
export {
  BaseSectionPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZVNlY3Rpb25QcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvQmFzZVNlY3Rpb25QcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0QmFzZVNlY3Rpb246IHtcblx0XHRhdHRyczoge1xuXHRcdFx0c2hvd0JhY2tCdXR0b246IHRydWUsXG5cdFx0fSxcblx0fSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBZSxxQkFBQTtBQUFBLEVBQ2QsYUFBYTtBQUFBLElBQ1osT0FBTztBQUFBLE1BQ04sZ0JBQWdCO0FBQUEsSUFDaEI7QUFBQSxFQUNEO0FBQ0Y7In0=
